import React, { FC, useContext } from 'react'
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography'
import BookingContext from '../contexts/booking'

import Loading from '@kaidam/fc-frontend/src/components/system/Loading'

import DateNavigator from '../components/booking/DateNavigator'
import Calendar from '../components/booking/Calendar'

const BookingCalendar: FC<React.PropsWithChildren<unknown>> = () => {
  const booking = useContext(BookingContext)
  
  // Add theme and media query hook
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))

  if(!booking.initialised) {
    return (
      <Loading />
    )
  }

  // Filter calendar data based on screen size
  const calendarData = isSmallScreen 
    ? booking.calendar.slice(0, 1) // Show only first day on small screens
    : booking.calendar // Show all days on larger screens

  return (
    <Box sx={{ p: 2 }}>
      <Typography
        gutterBottom
        variant="body1"
      >
        Choose the date and time for your booking:
      </Typography>
      <Box sx={{
        pt: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <DateNavigator
            value={ booking.calendarDate }
            earliest={ booking.earliestBookingDate }
            latest={ booking.latestBookingDate }
            onChange={ (date) => booking.setCalendarDate(date) }
          />
        </Box>
        <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Calendar
            data={ calendarData }
            length={ booking.data.product?.length || 0 }
            latest={ booking.latestBookingDate }
            onSubmit={ (date) => {
              booking.update({date})
              booking.openPage('details')
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default BookingCalendar